import { ICopyDeck, IFeed, IMemorialIntroductionProgressEvent } from "@/models/vimy.models";
import { VuexModule, Module, Action, Mutation } from "vuex-class-modules";
import { AppStore, DataStore, ModalStore } from ".";
import BusEvent from '../../../shared/js/BusEvent';

/* CALL EVENT EXAMPLE
    const eventThemeSet = new CustomEvent('memorial-theme-set', { detail: {
        id: 1
    }});

    document.dispatchEvent(eventThemeSet);
    setTimeout(() => {
        const eventModalOpen = new CustomEvent('memorial-modal-open', { detail: {
            id: 1
        }});

        document.dispatchEvent(eventModalOpen);
    }, 100);
*/

@Module
export class EventModule extends VuexModule {
    private _registered: boolean = false;
    private _ready: boolean = false;

    get registered() : boolean {
        return this._registered;
    }

    get ready(): boolean {
        return this._ready;
    }

    @Mutation
    private completeRegisteration() {
        this._registered = true;
    }

    @Mutation
    private setReady() {
        this._ready = true;
    }

    @Action
    registerAllListenners() : void {
        if (this.registered) return;

        this.registerReadyEvent();
        this.registerMemorialSetThemeEvent();
        this.registerMemorialModalOpenEvent();
        this.registerBreadcrumbEvent();
        this.registerOtherThemeEvent();
        this.registerShareTestimonialEvent();

        this.completeRegisteration();
    }

    @Action
    showFog(): void {
        document.dispatchEvent(new BusEvent(BusEvent.EVENTS.SHOW_FOG));
    }

    @Action
    hideFog(): void {
        document.dispatchEvent(new BusEvent(BusEvent.EVENTS.HIDE_FOG));
    }

    @Action
    triggerReady() : void {
        document.dispatchEvent(new BusEvent(BusEvent.EVENTS.READY_2D));
    }

    @Action
    triggerData(data: IFeed) : void {
        document.dispatchEvent(new BusEvent(BusEvent.EVENTS.DATA, data));
    }

    @Action
    triggerCopyDeck(data: ICopyDeck) : void {
        document.dispatchEvent(new BusEvent(BusEvent.EVENTS.COPYDECK, data));
    }

    @Action
    triggerIntroductionProgress(data: IMemorialIntroductionProgressEvent) : void {
        document.dispatchEvent(new BusEvent(BusEvent.EVENTS.INTRO_STEP, data));
    }

    @Action
    triggerIntroductionCompleted(fromClick : boolean = false) : void {
        document.dispatchEvent(new BusEvent(BusEvent.EVENTS.INTRO_COMPLETE, {fromClick}));
    }

    @Action
    triggerModalClosed(id: number) : void {
        document.dispatchEvent(new BusEvent(BusEvent.EVENTS.TESTIMONIAL_CLOSED, {
            themeId: DataStore.theme?.id,
            testimonialId: id
        }));
    }

    @Action
    triggerFinishExperience(): void {
        document.dispatchEvent(new BusEvent(BusEvent.EVENTS.FINISH_EXPERIENCE));
    }

    private registerBreadcrumbEvent() {
        document.addEventListener(BusEvent.EVENTS.BREADCRUMB_VISIBILITY, (event) => {
            const ev = event as BusEvent;
            DataStore.setBreadcrumbVisibility(ev.options.visibility);
        });

        document.addEventListener(BusEvent.EVENTS.ON_GET_VISITED_THEMES, (event) => {
            const ev = event as BusEvent;

            DataStore.setVisitedThemes(ev.options.visitedThemes);
        });

        document.addEventListener(BusEvent.EVENTS.SEND_TO_CREDITS, (event) => {
            AppStore.openCreditsAction();
        });
    }

    private registerOtherThemeEvent() {
        document.addEventListener(BusEvent.EVENTS.OTHER_THEMES_VISIBILITY, (event) => {
            const ev = event as BusEvent;
            DataStore.setOtherThemesVisibility(ev.options.visibility);
            DataStore.setOtherThemesLabel(ev.options.label ?? '');
            DataStore.setOtherThemesAction(ev.options.action ?? '');
        });
    }

    private registerShareTestimonialEvent() {
        document.addEventListener(BusEvent.EVENTS.SHARE_TESTIMONIAL_VISIBILITY, (event) => {
          //console.log(event);
            const ev = event as BusEvent;
            DataStore.setShareTestimonialVisibility(ev.options.visibility);
            //console.log("event SHARE_TESTIMONIAL_VISIBILITY triggered");
            //console.log(ev.options);
        });
    }

    private registerReadyEvent() {
        document.addEventListener(BusEvent.EVENTS.READY, (event) => {
            this.setReady();
        });
    }

    private registerMemorialSetThemeEvent() {
        document.addEventListener(BusEvent.EVENTS.CHANGE_THEME, (event) => {
            const ev = event as BusEvent;
            DataStore.setTheme(ev.options.id);
        });

        document.addEventListener(BusEvent.EVENTS.CHANGE_THEME, (event) => {
            const ev = event as BusEvent;
            DataStore.setBreadcrumbVisibility(false);
        });
    }

    private registerMemorialModalOpenEvent() {
        document.addEventListener(BusEvent.EVENTS.TESTIMONIAL_READY_TO_SLIDE_IN, (event) => {
            const ev = event as BusEvent;
            DataStore.setCurrentTestimonial(ev.options.testimonial);
            ModalStore.open(ev.options.testimonial.id);
        });
    }
}
